<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="detaydialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
                <v-flex pa-1 xs12 sm12 md12>
                <v-card>
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
              <v-layout wrap>
                <div class="flex md12">
                  <div v-show="codegorunum === true ">
                    <v-text-field label="Şablon ID" :color="color" hide-details="" v-model="SablonDetay.SablonID"
                      :error-messages="errors.collect('bankakod')" v-validate="'required'" data-vv-name="bankakod"
                      required>
                    </v-text-field>
                  </div>

                  <v-select :items="yedekalanid" clearable label="Alan ID" v-model="SablonDetay.AlanID" hide-details=""></v-select>
                  <v-text-field label="Alan Adı" :color="color" tabindex="3" hide-details="" v-model="SablonDetay.AlanAdi"
                    :error-messages="errors.collect('bankaadi')" v-validate="'required'" data-vv-name="bankaadi"
                    required>
                  </v-text-field>
                  <v-select :items="evethayir" clearable item-value="value" item-text="text" label="Zorunlu" v-model="SablonDetay.Zorunlu"
                    hide-details=""></v-select>
                  <v-select :items="evethayir" clearable item-value="value" item-text="text" label="Fatura" v-model="SablonDetay.Fatura"
                    hide-details=""></v-select>
                  <v-text-field label="Amedeus Kod" hide-details="" v-model="SablonDetay.AmedeusKod" :color="color"></v-text-field>
                  <v-text-field label="Galileo Kod" hide-details="" :color="color" v-model="SablonDetay.GalileoKod"></v-text-field>
                  <v-select :items="evethayir" clearable item-value="value" item-text="text" label="Anahtar" v-model="SablonDetay.Anahtar"
                    hide-details=""></v-select>
                </div>

              </v-layout>
              </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="sablondetaysil()">Sil</v-btn>
              <v-btn id="bguncelle" color="blue darken-1" flat @click="detayguncelle()">Güncelle</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click.native="detaydialog=false">Vazgeç</v-btn>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="detaykaydet()">Kaydet</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogaciklama" max-width="200px">
        <v-card>
          <v-card-title>
            Alan ID Açıklamaları
          </v-card-title>
          <v-card-text>

            <v-flex xs12 sm12>
              <h3> S: Düz Yazı.</h3>
            </v-flex>

            <v-flex xs12 sm12>
              <h3> B: Sayısal </h3>
            </v-flex>

            <v-flex xs12 sm12>
              <h3> D: Tarih </h3>
            </v-flex>

            <v-flex xs12 sm12>
              <h3> M: Para Birimi </h3>
            </v-flex>

          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="ekledialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container fluid="">
                <v-form ref="formcariyegore" v-model="valid" lazy-validation>
              <v-layout wrap>

                <div class="flex md12">
                  <v-text-field :rules="[v => !!v || 'Lütfen tarih seçiniz']"  label="Şablon Adı" hide-details="" v-model="Sablon.ProfileName" ></v-text-field>
                </div>

              </v-layout> </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click="eklevazgec()">Vazgeç</v-btn>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="profilkaydet()">Kaydet</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar color="info" size="120px" dark>
        <v-toolbar-title>Profil Şablon Dizayn</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>

        <v-btn hidden="xs" flat @click="ekle()"> <span class="hidden-sm-and-down"> Profil Şablon Ekle </span>
          <v-icon right dark>add_box</v-icon>
        </v-btn>
        <v-menu offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>

            <v-list-tile @click.native="dialogaciklama=true">
              <v-list-tile-title>Alan ID Açıklamaları</v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>



      </v-toolbar>
    </v-layout>

    <v-container fluid>
      <v-layout row wrap>

        <v-flex xs12 sm6 md6>
          <v-select :items="itemssablon" clearable item-value="ID" @change="detaygetir()" item-text="SablonAdi" label="Şablon Seçiniz"
            v-model="Sablon.TemplateID" hide-details=""></v-select>
        </v-flex>

        <v-flex xs12 v-if="detaykont">
          <v-card>
            <v-card-title>
              <v-flex>
                <v-btn color="info" @click="detayekle()"> Detay Ekle
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
              </v-flex>
              <v-spacer></v-spacer>


            </v-card-title>
            <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items" :search="search3">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr @click="Getir(props.item.ID,props.item.AlanID)" item>
                  <td class="text-xs-left">{{ props.item.AlanID }}</td>
                  <td class="text-xs-left">{{ props.item.AlanAdi }}</td>
                  <td class="text-xs-left">{{ props.item.Zorunlu }}</td>
                  <td class="text-xs-left">{{ props.item.Fatura }}</td>
                  <td class="text-xs-left">{{ props.item.AmedeusKod }}</td>
                  <td class="text-xs-left">{{ props.item.GalileoKod }}</td>
                </tr>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
              </v-alert>
            </v-data-table>
          </v-card>
          <template>
            <v-card>
              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
              </v-snackbar>
            </v-card>
          </template>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  export default {
    data() {
      return {
        i: 0,
        yedekalanid: [],
        yedekalanid1: ['S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8', 'S9', 'S10', 'S11', 'S12', 'S13', 'S14', 'S15',
          'S16',
          'S17', 'S17', 'S18', 'S19', 'S20', 'S21', 'S22', 'S23', 'S24', 'S25', 'S26', 'S27', 'S28', 'S29', 'S30',
          'S31', 'S32', 'S33', 'S34', 'S35', 'S36', 'S37', 'S38', 'S39', 'S40', 'S41', 'S42', 'S43', 'S44', 'S45',
          'S46', 'S47', 'S48', 'S49', 'S50', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D7', 'D8', 'D9', 'D10',
          'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8',
          'M9', 'M10'
        ],

        alanid: ['S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8', 'S9', 'S10', 'S11', 'S12', 'S13', 'S14', 'S15', 'S16',
          'S17', 'S17', 'S18', 'S19', 'S20', 'S21', 'S22', 'S23', 'S24', 'S25', 'S26', 'S27', 'S28', 'S29', 'S30',
          'S31', 'S32', 'S33', 'S34', 'S35', 'S36', 'S37', 'S38', 'S39', 'S40', 'S41', 'S42', 'S43', 'S44', 'S45',
          'S46', 'S47', 'S48', 'S49', 'S50', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D7', 'D8', 'D9', 'D10',
          'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M7', 'M8',
          'M9', 'M10'
        ],
valid:true,
        alanid1: [{
            value: 'S1',
            text: 'S1 - Düz Yazı'
          },
          {
            value: 'S2',
            text: 'S2 - Düz Yazı'
          },
          {
            value: 'S3',
            text: 'S3 - Düz Yazı'
          },
          {
            value: 'S4',
            text: 'S4 - Düz Yazı'
          },
          {
            value: 'S5',
            text: 'S5 - Düz Yazı'
          },
          {
            value: 'S6',
            text: 'S6 - Düz Yazı'
          },
          {
            value: 'S7',
            text: 'S7 - Düz Yazı'
          },
          {
            value: 'S8',
            text: 'S8 - Düz Yazı'
          },
          {
            value: 'S9',
            text: 'S9 - Düz Yazı'
          },
          {
            value: 'S10',
            text: 'S10 - Düz Yazı'
          },
          {
            value: 'S11',
            text: 'S11 - Düz Yazı'
          },
          {
            value: 'S12',
            text: 'S12 - Düz Yazı'
          },
          {
            value: 'S13',
            text: 'S13 - Düz Yazı'
          },
          {
            value: 'S14',
            text: 'S14 - Düz Yazı'
          },
          {
            value: 'S15',
            text: 'S15 - Düz Yazı'
          },
          {
            value: 'S16',
            text: 'S16 - Düz Yazı'
          },
          {
            value: 'S17',
            text: 'S17 - Düz Yazı'
          },
          {
            value: 'S18',
            text: 'S18 - Düz Yazı'
          },
          {
            value: 'S19',
            text: 'S19 - Düz Yazı'
          },
          {
            value: 'S20',
            text: 'S20 - Düz Yazı'
          },
          {
            value: 'S21',
            text: 'S21 - Düz Yazı'
          },
          {
            value: 'S22',
            text: 'S22 - Düz Yazı'
          },
          {
            value: 'S23',
            text: 'S23 - Düz Yazı'
          },
          {
            value: 'S24',
            text: 'S24 - Düz Yazı'
          },
          {
            value: 'S25',
            text: 'S25 - Düz Yazı'
          },
          {
            value: 'S26',
            text: 'S26 - Düz Yazı'
          },
          {
            value: 'S27',
            text: 'S27 - Düz Yazı'
          },
          {
            value: 'S28',
            text: 'S28 - Düz Yazı'
          },
          {
            value: 'S29',
            text: 'S29 - Düz Yazı'
          },
          {
            value: 'S30',
            text: 'S30 - Düz Yazı'
          },
          {
            value: 'S31',
            text: 'S31 - Düz Yazı'
          },
          {
            value: 'S32',
            text: 'S32 - Düz Yazı'
          },
          {
            value: 'S33',
            text: 'S33 - Düz Yazı'
          },
          {
            value: 'S34',
            text: 'S34 - Düz Yazı'
          },
          {
            value: 'S35',
            text: 'S35 - Düz Yazı'
          },
          {
            value: 'S36',
            text: 'S36 - Düz Yazı'
          },
          {
            value: 'S37',
            text: 'S37 - Düz Yazı'
          },
          {
            value: 'S38',
            text: 'S38 - Düz Yazı'
          },
          {
            value: 'S39',
            text: 'S39 - Düz Yazı'
          },
          {
            value: 'S40',
            text: 'S40 - Düz Yazı'
          },
          {
            value: 'S41',
            text: 'S41 - Düz Yazı'
          },
          {
            value: 'S42',
            text: 'S42 - Düz Yazı'
          },
          {
            value: 'S43',
            text: 'S43 - Düz Yazı'
          },
          {
            value: 'S44',
            text: 'S44 - Düz Yazı'
          },
          {
            value: 'S45',
            text: 'S45 - Düz Yazı'
          },
          {
            value: 'S46',
            text: 'S46 - Düz Yazı'
          },
          {
            value: 'S47',
            text: 'S47 - Düz Yazı'
          },
          {
            value: 'S48',
            text: 'S48 - Düz Yazı'
          },
          {
            value: 'S49',
            text: 'S49 - Düz Yazı'
          },
          {
            value: 'S50',
            text: 'S50 - Düz Yazı'
          },
          {
            value: 'D1',
            text: 'D1 - Tarih'
          },
          {
            value: 'D2',
            text: 'D2 - Tarih'
          },
          {
            value: 'D3',
            text: 'D3 - Tarih'
          },
          {
            value: 'D4',
            text: 'D4 - Tarih'
          },
          {
            value: 'D5',
            text: 'D5 - Tarih'
          },
          {
            value: 'D6',
            text: 'D6 - Tarih'
          },
          {
            value: 'D7',
            text: 'D7 - Tarih'
          },
          {
            value: 'D8',
            text: 'D8 - Tarih'
          },
          {
            value: 'D9',
            text: 'D9 - Tarih'
          },
          {
            value: 'D10',
            text: 'D10 - Tarih'
          },
          {
            value: 'B1',
            text: 'B1 - Sayısal'
          },
          {
            value: 'B2',
            text: 'B2 - Sayısal'
          },
          {
            value: 'B3',
            text: 'B3 - Sayısal'
          },
          {
            value: 'B4',
            text: 'B4 - Sayısal'
          },
          {
            value: 'B5',
            text: 'B5 - Sayısal'
          },
          {
            value: 'B6',
            text: 'B6 - Sayısal'
          },
          {
            value: 'B7',
            text: 'B7 - Sayısal'
          },
          {
            value: 'B8',
            text: 'B8 - Sayısal'
          },
          {
            value: 'B9',
            text: 'B9 - Sayısal'
          },
          {
            value: 'B10',
            text: 'B10 - Sayısal'
          },
          {
            value: 'M1',
            text: 'M1 - Para Birimi'
          },
          {
            value: 'M2',
            text: 'M2 - Para Birimi'
          },
          {
            value: 'M3',
            text: 'M3 - Para Birimi'
          },
          {
            value: 'M4',
            text: 'M4 - Para Birimi'
          },
          {
            value: 'M5',
            text: 'M5 - Para Birimi'
          },
          {
            value: 'M6',
            text: 'M6 - Para Birimi'
          },
          {
            value: 'M7',
            text: 'M7 - Para Birimi'
          },
          {
            value: 'M8',
            text: 'M8 - Para Birimi'
          },
          {
            value: 'M9',
            text: 'M9 - Para Birimi'
          },
          {
            value: 'M10',
            text: 'M10 - Para Birimi'
          },
        ],

        evethayir: [{
            text: 'Evet',
            value: 'E'
          },

          {
            text: 'Hayır',
            value: 'H'
          }
        ],

        headers: [{
            text: 'Alan ID',
            value: 'AlanID'
          },

          {
            text: 'Alan Adı',
            value: 'AlanAdi'
          },
          {
            text: 'Zorunlu',
            value: 'Zorunlu'
          },
          {
            text: 'Fatura',
            value: 'Fatura'
          },
          {
            text: 'Amedeus Kod',
            value: 'AmedeusKod'
          },
          {
            text: 'Galileo Kod',
            value: 'GalileoKod'
          }

        ],

        loading: false,
        color: 'orange darken-4',
        items: [],
        itemssablon: [],
        search3: '',
        search: null,
        select: [],
        detaykont: false,
        selected: '',
        m: false,
        k: false,
        detaydialog: false,
        dialogaciklama: false,
        renk1: 'info',
        ekledialog: false,
        SablonDetay: {
          ID: '',
          SablonID: '',
          AlanID: '',
          AlanAdi: '',
          Zorunlu: '',
          Fatura: '',
          AmedeusKod: '',
          GalileoKod: '',
          Anahtar: ''
        },

        Sablon: {
          ProfileName: '',
          TemplateID: '',
          DetailID: '',
          ProfileID: ''
        },

        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
        yedekkod: '',
        dictionary: {
          custom: {

            sablon: {
              required: () => 'Bu alan boş bırakılamaz',
            },
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('tr', this.dictionary)
    },
    methods: {
      Getir(v, y) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.yedekalanid = this.yedekalanid1
        this.yedekkod = y

        this.items.forEach(element => {
          var index = this.yedekalanid.indexOf(String(element.AlanID))
          if (index > -1) {
            this.yedekalanid.splice(index, 1);
          }
        });

        this.yedekalanid.unshift(this.yedekkod)
        this.dialog_baslik = 'Müşteri Personel Bilgileri Güncelle'

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          CompanyCode: credentials.SirketKodu,
          DetailID: v
        }

        this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.SablonDetay = response.body
          this.detaydialog = true

        })
      },
      ekle: ekle,
      eklevazgec: eklevazgec,
      profilkaydet: profilkaydet,
      guncelle: guncelle,
      vazgec: vazgec,
      detaygetir: detaygetir,
      detayekle: detayekle,
      detaykaydet: detaykaydet,
      sablondetaysil: sablondetaysil,
      detayguncelle: detayguncelle
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }


  function detayekle() {

    this.yedekalanid = this.alanid1

    this.items.forEach(element => {
      var index = this.yedekalanid.indexOf(String(element.AlanID))
      if (index > -1) {
        this.yedekalanid.splice(index, 1);
      }
    });

    this.detaydialog = true
    this.dialog_baslik = "Profil Şablon Detay Ekle"
    this.SablonDetay = {}
    this.SablonDetay.SablonID = this.Sablon.TemplateID
    this.codegorunum = false
    this.k = true
    this.m = false
  }

  function detaykaydet() {
    var params = this.SablonDetay
    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.snackbar = true
      this.detaydialog = false
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        CompanyCode: credentials.SirketKodu,
        TemplateID: this.Sablon.TemplateID
      }

      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.items = response.body
        this.detaykont = true
        this.progress = false
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false
        }
      })
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })
  }

  function sablondetaysil() {
    if (window.confirm('Detay\'ı silmek istediğinize emin misiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        DetailID: this.SablonDetay.ID,
        CompanyCode: credentials.SirketKodu
      }
      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.detaydialog = false
          var params1 = {
            CompanyCode: credentials.SirketKodu,
            TemplateID: this.SablonDetay.SablonID
          }

          this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.detaykont = true
            this.progress = false
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.detaykont = false
              this.progress = false

            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.detaykont = false
              this.progress = false
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.progress = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function detayguncelle() {

    var params = this.SablonDetay
    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      this.snackbar = true
      this.detaydialog = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var params = {
        CompanyCode: credentials.SirketKodu,
        TemplateID: this.Sablon.TemplateID
      }

      this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.items = response.body
        this.detaykont = true
        this.progress = false

      }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false

        } else {

          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.detaykont = false
          this.progress = false

        }
      })
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })
  }

  function eklevazgec() {
    this.ekledialog = false
    this.Sablon.ProfileName = null
  }

  function vazgec() {
    this.dialog = false
    this.search = ''
  }

  function detaygetir() {
    this.yedekalanid = new Array();
    this.yedekalanid1.forEach(element => {
      this.yedekalanid.push(element)
    });


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
      CompanyCode: credentials.SirketKodu,
      TemplateID: this.Sablon.TemplateID
    }

    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDetailList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.items = response.body
      this.detaykont = true
      this.progress = false

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false

      } else {

        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.detaykont = false
        this.progress = false
      }
    })
  }

  function profilkaydet() {

       if (this.$refs.formcariyegore.validate()) {


        var params = this.Sablon

        this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.detaydialog = false

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          var params1 = {
            CompanyCode: credentials.SirketKodu,
          }

          this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.itemssablon = response.body
            this.ekledialog = false
            this.detaykont = false
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.detaykont = false
              this.progress = false
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.detaykont = false
              this.progress = false
            }
          })
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.detaykont = false
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.detaykont = false
            this.progress = false
          }
        })
      }


  }

  function ekle() {
    this.ekledialog = true
    this.dialog_baslik = 'Yeni Şablon Ekle'
    this.k = true
    this.m = false
    this.$validator.reset()
  }

  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      SirketKodu: credentials.SirketKodu
    }
    this.progress = true
    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemssablon = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }

  function guncelle() {

    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.MusteriPersonel.SirketKodu = credentials.SirketKodu
        var params = this.MusteriPersonel
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = 'Güncelleme işlemi tamamlandı'
            this.snackbar = true
            var params1 = {
              SirketKodu: credentials.SirketKodu
            }
            this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>